module.exports = __webpack_public_path__ + "static/studio-01-b7ec056f71854c2c06c8bc5cb627b3d0.webp";